// extracted by mini-css-extract-plugin
module.exports = {"card":"EventImage_card__2EtfC","grid":"EventImage_grid__1mbl7","wrapper":"EventImage_wrapper__2plW2","photo":"EventImage_photo__24Uqh","list":"EventImage_list__71xPb"};